<template>
	<v-container fluid pt-0>
		<v-row wrap>
			<v-col cols="12" class="pt-0">
				<v-card flat outlined>
					<v-card-text>
						<v-row>
							<v-col>
								<v-data-table
									:items="activityList"
									fixed-header
									dense
									class="row-item"
									:items-per-page="-1"
									:hide-default-header="true"
									:hide-default-footer="true"
									:height="250"
									:no-data-text="$t('labels.noActivities')"
								>
									<template v-slot:item="row">
										<tr>
											<td>
												<v-row dense>
													<v-col cols="2">
														{{ row.item.userData }} <br />
														{{ row.item.created_at }}
													</v-col>
													<v-col cols="10">
														<v-card v-if="row.item.inspection_id" class="pa-2">
															{{ $t('fields.name') + ': ' }}
															{{ row.item.inspection.name }}
															<br />
															{{ $t('fields.description') + ': ' }}
															{{ row.item.inspection.activity_description }}
														</v-card>
														<v-card v-else class="pa-2">
															{{ row.item.equipment_activity_note.content }}
														</v-card>
													</v-col>
												</v-row>
											</td>
										</tr>
									</template>
									<template v-slot:footer v-if="$myStore.state.user.user_role_id == 1">
										<v-row dense>
											<v-col cols="10" class="pl-4">
												<InputField
													v-model="equipmentActivityNote.content"
													:errorBorder="!equipmentActivityNoteValidation.content"
													:label="$t('fields.note')"
													@keypress.native.enter="saveEquipmentActivityNote"
												></InputField>
											</v-col>
											<v-col cols="2" class="pl-2 mt-2">
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															color="primary"
															class="mr-2 mt-2"
															v-bind="attrs"
															@click="saveEquipmentActivityNote()"
															v-on="on"
														>
															<v-icon small>fa-plus</v-icon>
														</v-btn>
													</template>
													<span>{{ $t('tooltips.addEquipmentActivityNote') }}</span>
												</v-tooltip>
											</v-col>
										</v-row>
									</template>
								</v-data-table>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import EquipmentActivity from '../../../models/EquipmentActivity';
import EquipmentActivityNote from '../../../models/EquipmentActivityNote';
import InputField from '../../trinkets/InputField';

export default {
	name: 'Activities',
	components: { InputField },
	props: {
		inEditMode: Boolean,
		equipmentId: [Number, String],
	},
	data() {
		return {
			equipmentActivity: new EquipmentActivity({ equipment_id: this.equipment_id }),
			equipmentActivityNote: new EquipmentActivityNote({}),
			equipmentActivityNoteValidation: new EquipmentActivityNote({}, true),
			activityList: [],
		};
	},
	created() {
		if (this.equipmentId != 0) {
			this.reloadData();
		}
	},
	mounted() {
		let vm = this;
		this.$modalBus.$on('reloadActivities', () => {
			vm.reloadData();
		});
	},
	methods: {
		reloadData() {
			let vm = this;
			this.$APICall(
				'get',
				'equipment-activities/' + this.equipmentId,
				{},
				(data, success) => {
					if (success) {
						vm.activityList = data.items;
					}
				},
				false
			);
		},
		saveEquipmentActivityNote() {
			let success = true;
			let errorMessages = '';
			if (this.equipmentActivityNote.content == '') {
				success = false;
				this.equipmentActivityNoteValidation.content = false;
			} else {
				if (this.equipmentActivityNote.content.length > 500) {
					this.equipmentActivityNoteValidation.content = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.note'))
							.replace('%length%', '500') + '<br />';
				} else {
					this.equipmentActivityNoteValidation.content = true;
				}
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				this.equipmentActivityNote.user_id = this.$myStore.state.user.id;
				this.equipmentActivityNote.equipment_id = this.equipmentId;
				this.$APICall('post', 'equipment-activity-notes', this.equipmentActivityNote, (data, success) => {
					if (success) {
						vm.$notify(vm.$t('alerts.basicAdd'));
						vm.equipmentActivityNote = new EquipmentActivityNote({});
						vm.reloadData();
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
	},
};
</script>
